/**
 * Layout Component
 * ================
 * Main layout wrapper for the application.
 * Includes navigation, footer, and scroll progress indicator.
 */

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { ScrollProgress } from '../animations/ScrollProgress';

/**
 * Layout Component
 * Provides consistent layout structure across pages.
 * 
 * @returns {JSX.Element} Layout component
 */
export function Layout() {
  const location = useLocation();
  
  // Don't show scroll progress on certain pages
  const hideProgressOn = ['/login', '/demo', '/dashboard'];
  const showProgress = !hideProgressOn.includes(location.pathname);
  
  // Hide navigation and footer on demo page for full-screen experience
  const hideNavFooterOn = ['/demo'];
  const showNavFooter = !hideNavFooterOn.includes(location.pathname);
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* Scroll Progress Indicator */}
      {showProgress && <ScrollProgress />}
      
      {/* Navigation */}
      {showNavFooter && <Navigation />}
      
      {/* Main Content */}
      <main className={`flex-1 ${!showNavFooter ? 'pt-0' : ''}`}>
        <Outlet />
      </main>
      
      {/* Footer */}
      {showNavFooter && <Footer />}
    </div>
  );
}

export default Layout;
